import React from 'react';
import ImagePreviewUploader from 'components/ImagePreview';

const UploadLogo = ({ branding }) => {
    return  <>
                <ImagePreviewUploader
                    branding={branding}
                />
            </>;
};

export default UploadLogo;
